<template>

    <div :class="[!is_enabled ? 'cursor-pointer hover:bg-gray-100' : '', 'group']" @click="clickRow">

        <div :class="['flex items-center font-bold flex-row justify-between px-4 py-5 sm:p-6']">

            <div class="flex flex-grow items-center gap-3">
                <div class="w-12 h-12 rounded-2xl flex items-center justify-center"
                    :style="'background-color:' + color">
                    <img :src="'/img/' + logo" :class="'h-' + logoSize + ' w-' + logoSize" />
                </div>

                <div class="flex flex-col items-start">
                    <span>{{ _name }}</span>
                </div>
            </div>

            <div v-if="is_enabled && $page.props.canManageSettings" class="flex text-white bg items-center">
                <button-link link="#" @click.prevent="disableUl" class="bg-birdie-green text-white"
                    :title="'Disable ' + _name + ' integration'">
                    Disable
                </button-link>
            </div>

            <transition name="fade">
                <div v-if="expandInfo && !is_enabled && !is_custom" class="flex text-blue-500 items-center"
                    :class="{ 'opacity-50 pointer-events-none': !$page.props.canManageSettings }">
                    <button-link link="#" @click.prevent="enableUl" class="" :title="'Enable ' + name + ' integration'"
                        :disabled="!$page.props.canManageSettings">
                        Enable
                    </button-link>
                </div>
            </transition>

            <transition name="fade">
                <div v-if="expandInfo && !is_enabled && is_custom" class="flex text-blue-500 items-center min-w-80  ">
                    <div class="mt-2 flex">
                        <div class="-mr-px grid grow grid-cols-1 focus-within:relative"
                            :class="{ 'pointer-events-none': !$page.props.canManageSettings }">
                            <input type="text" name="form_name" id="form_name" v-model="_form_name"
                                class="col-start-1 row-start-1 block w-full rounded-l-md bg-white py-1.5 pl-10 pr-3 text-base border border-gray-300 placeholder:text-gray-400 focus:border-gray-700 text-gray-900 sm:pl-9 sm:text-sm/6 font-normal ring-0 outline-none focus:outline-none focus:ring-0"
                                @click.stop placeholder="Helpdesk name…" :disabled="!$page.props.canManageSettings" />
                            <Cog6ToothIcon
                                class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-400 sm:size-4 "
                                aria-hidden="true" />
                        </div>
                        <button type="button"
                            class="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700 active:bg-gray-900 focus:outline-none focus:border-gray-900 focus:ring focus:ring-gray-300 transition rounded-r-md"
                            :class="{
                                'opacity-50 pointer-events-none': !$page.props.canManageSettings,
                                'disabled: opacity-25': _form_name.length < 3
                            }" :disabled="_form_name.length < 3" @click.stop="enableUl">
                            Enable
                        </button>
                    </div>

                </div>
            </transition>

        </div>


        <Flows :visible="expandInfo" :fixed="is_enabled" :flows="flows" :docs="docs" :is_custom="is_custom"
            :name="name" />


        <div v-if="is_enabled" class="bg-gray-50 rounded-b-md px-4 py-4 sm:p-8 border-t border-gray-100">

            <div class="flex flex-col" v-if="!is_modal">
                <div class="flex items-center flex-grow">
                    <div class="flex justify-between items-center gap-x-2">

                        <span class="flex flex-shrink items-center gap-x-2">
                            Request Link to paste into your {{ _name }} flow:
                        </span>

                        <div class="flex flex-grow justify-between text-sm">
                            <span
                                class="cursor-pointer bg-gray-200 text-gray-500 hover:text-gray-600 px-3 py-1 rounded mt-0 flex items-center flex-shrink"
                                v-clipboard:copy="universal_link" v-clipboard:success="confirmCopy">{{ universal_link }}
                                <ClipboardIcon class="h-3 w-3 ml-1" v-tippy="{ content: 'copy in your clipboard' }" />
                            </span>
                            <div class="flex flex-grow"></div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>

</template>

<script>

import ButtonLink from '@/Jetstream/ButtonLink'
import { ClipboardIcon, Cog6ToothIcon } from '@heroicons/vue/16/solid'
import Flows from '@/Components/Settings/Integrations/Flows'


export default {

    props: ['enabled', "is_modal", "name", "docs", "slug", "logo", "logoSize", "color", "flows", "is_custom"],

    components: {
        ButtonLink, ClipboardIcon, Flows, Cog6ToothIcon
    },

    created: function () {
        this.is_enabled = this.enabled
    },

    data() {
        return {
            is_enabled: false,
            saving: false,
            expandInfo: false,
            _name: this.name,
            _slug: this.slug,
            _form_name: ''
        }
    },

    mounted: function () {
        //console.log(this.engine);

    },

    methods: {
        clickRow: function () {
            if (this.is_enabled) {
                return
            }
            this.expandInfo = !this.expandInfo
        },
        enableUl: function () {
            if (!this.$page.props.canManageSettings) {
                return
            }
            if (this.saving) {
                return
            }
            if (this.is_custom && this._form_name.length < 3) {
                return
            }

            this.saving = true
            let url = this.$page.props.api_url + '/v1/team/enable_ul';
            var params = {
                slug: `${this._slug}`
            };
            if (this.is_custom) {
                params.form_name = `${this._form_name}`
            } else {
                params.name = `${this._name}`
            }
            axios.post(url, params)
                .then(response => {
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Setting updated", options)
                    this.is_enabled = true
                    this.saving = false
                    this._slug = response.data.slug
                    this._name = response.data.name
                    this._form_name = ''
                    this.$emit('update', response.data.universal_recorders, this._slug)
                })
                .catch(e => {
                    console.error(e);
                    this.saving = false
                });

        },

        disableUl: function () {
            if (!this.$page.props.canManageSettings) {
                return
            }
            if (this.saving) {
                return
            }
            this.saving = true
            let url = this.$page.props.api_url + '/v1/team/disable_ul';
            var params = {
                slug: `${this._slug}`
            };
            axios.post(url, params)
                .then(response => {
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Setting updated", options)
                    this.is_enabled = false
                    this.saving = false
                    if (this.is_custom) {
                        this._slug = ''
                        this._name = 'Other Helpdesk'
                    }
                    // console.log(response.data.universal_recorders, this._slug)
                    this.$emit('update', response.data.universal_recorders, this._slug)
                })
                .catch(e => {
                    console.error(e);
                    this.saving = false
                });

        },


        confirmCopy: function () {
            let options = {
                type: "default",
                timeout: 6000,
                position: "top-right",
                hideProgressBar: false,
            }
            this.$moshaToast("Copied in your clipboard!", options)
        },
        errorCopy: function () {
            let options = {
                type: "danger",
                timeout: -1,
                position: "top-right",
            }
            this.$moshaToast("A browser error occured, link not copied", options)
        },

    },

    computed: {

        universal_link: {
            get: function () {
                return `https://${this.$page.props.user.current_team.slugname}.birdie.so/urec/${this._slug}`
            },
            set: function (newValue) {
                // do nothing
            }
        },
    }
}

</script>
